module.exports = __webpack_public_path__ + "static/media/bolso (33).867a836a.jpg";